module.exports = __webpack_public_path__ + "static/img/taskBoxBg.a3c32cc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/taskBoxBg.webp
// module id = 147O
// module chunks = 0